<div class="cmdk-personprev">
  <div class="cmdk-personprev__head">
    <span class="cmdk-personprev__face">
      <span class="cmdk-personprev__avatar" aria-hidden="true" [imPersonColour]="item().title">{{ initials() }}</span>
      <im-call-presence-dot [personId]="item().id" />
    </span>
    <div class="cmdk-personprev__ident">
      <h3 class="cmdk-personprev__title">{{ item().title }}</h3>
      @if (item().subtitle) {
        <p class="cmdk-personprev__sub">{{ item().subtitle }}</p>
      }
      @if (inCall()) {
        <p class="cmdk-personprev__sub" data-testid="emp.shell.cmdk.preview.person.in-call">{{ inCallLabel() }}</p>
      }
    </div>
  </div>

  <section class="cmdk-personprev__section">
    <h4 class="cmdk-personprev__section-title">{{ detailsLabel() }}</h4>
    <dl class="cmdk-personprev__facts">
      @for (fact of facts(); track fact.label) {
        <div class="cmdk-personprev__fact">
          <dt>{{ fact.label }}</dt>
          <dd>{{ fact.value }}</dd>
        </div>
      }
    </dl>
  </section>

  <div class="cmdk-personprev__actions">
    @if (canCall()) {
      <paper-button
        intent="secondary"
        size="sm"
        icon="phone"
        data-testid="emp.shell.cmdk.preview.person.call"
        (click)="call.emit()">
        {{ callLabel() }}
      </paper-button>
    }
    <paper-button
      intent="primary"
      size="sm"
      data-testid="cmdk-preview-run"
      (click)="activated.emit()">
      {{ openLabel() }}
    </paper-button>
    <paper-kbd keys="↵" label="Enter" size="sm" />
  </div>
</div>
